export default class SelectBar {
    private select: HTMLSelectElement | null;
    private input: HTMLInputElement | null;
    private currentValue: string;

    constructor(private root: HTMLElement) {
        this.select = this.root.querySelector<HTMLSelectElement>("select");
        this.input = this.root.querySelector<HTMLInputElement>("#theme");
        this.currentValue = this.select?.value || "";
    }

    public init = async () => {
        this.select?.addEventListener("change", this.handleSelect);

        this.updateInput();
    };

    private handleSelect = (e: Event) => {
        if (e.target) {
            this.currentValue = (e.target as HTMLSelectElement).value;
            this.updateInput();
        }
    };

    private updateInput = () => {
        if (this.input) {
            this.input.value = `${this.currentValue}`;
        }
    };
}
